import React from 'react';
import { Switch, Button, Tooltip, Iconfont, UmuInput } from '@umu/umu-design';
import { TextareaChangeData } from '@umu/umu-design/es/components/UmuInput';

const { Textarea } = UmuInput;

/**
 * 水印配置组件 Props
 */
export interface IWatermarkSettingProps {
    /** 水印开关状态 */
    watermarkEnabled: boolean;
    /** 水印配置字符串 */
    watermarkConfigString: string;
    /** 设置水印开关状态 */
    setWatermarkEnabled: (enabled: boolean) => void;
    /** 设置水印配置字符串 */
    setWatermarkConfigString: (config: string) => void;
    /** 应用水印配置 */
    applyWatermark: () => void;
    /** 自定义类名 */
    className?: string;
}

/**
 * 水印配置组件
 */
const WatermarkSetting: React.FC<IWatermarkSettingProps> = ({
    watermarkEnabled,
    watermarkConfigString,
    setWatermarkEnabled,
    setWatermarkConfigString,
    applyWatermark,
    className = '',
}) => {
    /**
     * 处理生效按钮点击
     */
    const handleApply = (): void => {
        try {
            // 验证 JSON 格式
            if (watermarkConfigString.trim()) {
                JSON.parse(watermarkConfigString.trim());
            }
            applyWatermark();
        } catch (error) {
            console.error('水印配置解析失败:', error);
        }
    };

    return (
        <div
            className={`watermark-setting ${className}`}
            style={{ marginBottom: '16px', padding: '16px', border: '1px solid #e0e0e0', borderRadius: '4px' }}
        >
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '12px' }}>
                <span style={{ marginRight: '12px', fontWeight: 'bold' }}>水印设置</span>
                <Switch
                    checked={watermarkEnabled}
                    onChange={(checked: boolean) => {
                        setWatermarkEnabled(checked);
                    }}
                />
            </div>
            {watermarkEnabled && (
                <div style={{ marginTop: '12px' }}>
                    <div style={{ marginBottom: '8px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '4px' }}>
                            <label style={{ fontSize: '14px', marginRight: '4px' }}>水印配置（JSON 格式）：</label>
                            <Tooltip
                                title={
                                    <div style={{ fontSize: '12px', lineHeight: '1.6' }}>
                                        <div style={{ marginBottom: '4px', fontWeight: 'bold' }}>字段说明：</div>
                                        <div style={{ marginBottom: '2px' }}>
                                            <strong>text</strong>: 水印文本内容（字符串，如："UMU"）
                                        </div>
                                        <div style={{ marginBottom: '2px' }}>
                                            <strong>color</strong>: 水印颜色（十六进制颜色值，如："#999"）
                                        </div>
                                        <div style={{ marginBottom: '2px' }}>
                                            <strong>size</strong>: 水印字号大小（数字，如：18）
                                        </div>
                                        <div style={{ marginBottom: '2px' }}>
                                            <strong>trasparency</strong>: 水印透明度（0-1之间的数字，如：0.2）
                                        </div>
                                        <div style={{ marginBottom: '2px' }}>
                                            <strong>rotate</strong>: 水印旋转角度（数字，如：30，单位：度）
                                        </div>
                                        <div style={{ marginBottom: '2px' }}>
                                            <strong>rows</strong>: 水印展示的行数（数字，如：6）
                                        </div>
                                        <div style={{ marginBottom: '2px' }}>
                                            <strong>splitCount</strong>: 每行的水印数量（数字，如：4）
                                        </div>
                                    </div>
                                }
                                placement="right"
                            >
                                <Iconfont
                                    type="Tips"
                                    style={{
                                        cursor: 'help',
                                        color: '#1890ff',
                                        fontSize: '14px',
                                        marginLeft: '4px',
                                    }}
                                />
                            </Tooltip>
                        </div>
                        <div style={{ width: '100%' }}>
                            <Textarea
                                value={watermarkConfigString}
                                onChange={(data: TextareaChangeData) => {
                                    const { value } = data;
                                    if (value !== undefined && value !== null) {
                                        setWatermarkConfigString(value);
                                    }
                                }}
                                expandConfig={{ placeholder: '请输入水印配置（JSON 格式）' }}
                            />
                        </div>
                        <style>{`
                            .watermark-setting textarea {
                                width: 100% !important;
                                min-height: 100px !important;
                                font-family: monospace !important;
                            }
                        `}</style>
                    </div>
                    <div style={{ marginTop: '8px' }}>
                        <Button type="primary" onClick={handleApply}>
                            生效
                        </Button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default WatermarkSetting;

